import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Card = styled.div`
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const TooltipRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: inherit;
`;

export const TooltipName = styled.strong`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.text['main-900']};
`;

export const TooltipValue = styled.div`
  font-size: 12px;
  color: ${colors.text['sub-500']};
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.text['main-900']};
`;

export const ScrollArea = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.stroke['soft-200']};
    border-radius: 4px;
  }
`;

export const ChartArea = styled.div`
  height: 320px;
`;

export const SkeletonLayout = styled.div`
  width: 100%;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 8px 32px;
`;

export const SkeletonBar = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-width: 0;

  > span {
    width: 100%;
    max-width: 32px;
  }
`;
